<template>
    <div class="impressions">

        <div class="impressions-grid"
            @click="onClick">
            <slot></slot>
        </div>

        <!-- Wichtig: <div class="pswp"> direkt ohne Leerzeichen/Zeilenumbruch anschließen,
		     weil voffice-photoswipe this.$el.firstChild als PhotoSwipe-Element nutzt. -->
        <voffice-photoswipe :items="items"
            :index.sync="openIndex">
            <div class="pswp"
                tabindex="-1"
                role="dialog"
                aria-hidden="true">
                <div class="pswp__bg"></div>
                <div class="pswp__scroll-wrap">
                    <div class="pswp__container">
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                    </div>
                    <div class="pswp__ui pswp__ui--hidden">
                        <div class="pswp__top-bar">
                            <div class="pswp__counter"></div>
                            <button class="pswp__button pswp__button--close"
                                title="Close (Esc)"></button>
                            <button class="pswp__button pswp__button--fs"
                                title="Toggle fullscreen"></button>
                            <button class="pswp__button pswp__button--zoom"
                                title="Zoom in/out"></button>
                            <div class="pswp__preloader">
                                <div class="pswp__preloader__icn">
                                    <div class="pswp__preloader__cut">
                                        <div class="pswp__preloader__donut"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                            <div class="pswp__share-tooltip"></div>
                        </div>
                        <button class="pswp__button pswp__button--arrow--left"
                            title="Previous (arrow left)"></button>
                        <button class="pswp__button pswp__button--arrow--right"
                            title="Next (arrow right)"></button>
                        <div class="pswp__caption">
                            <div class="pswp__caption__center"></div>
                        </div>
                    </div>
                </div>
            </div>
        </voffice-photoswipe>

    </div>
</template>

<script>
    export default {
    	voVueComponent: 'voffice-impressions',

    	data() {
    		return {
    			items: [],
    			openIndex: undefined
    		}
    	},

    	methods: {
    		onClick: function(e) {
    			var link = e.target.closest('.impressions-item');
    			if (!link) {
    				return;
    			}
    			e.preventDefault();

    			var links = Array.prototype.slice.call(this.$el.querySelectorAll('.impressions-item'));
    			var index = links.indexOf(link);

    			this.getItems(links).then((items) => {
    				this.items = items;
    				this.openIndex = index;
    			});
    		},

    		getItems: function(links) {
    			// Einmal ermitteln und danach wiederverwenden
    			if (!this.itemsPromise) {
    				this.itemsPromise = Promise.all(links.map((l) => this.buildItem(l)));
    			}
    			return this.itemsPromise;
    		},

    		buildItem: function(link) {
    			var src = link.getAttribute('href');
    			var img = link.querySelector('img');

    			var item = {
    				src: src,
    				// Vorschaubild als Platzhalter – nur wenn Lazyload es schon geladen hat
    				msrc: img ? (img.currentSrc || img.getAttribute('src') || undefined) : undefined,
    				title: img ? (img.getAttribute('title') || img.getAttribute('alt')) : ''
    			};

    			// Bevorzugt: Größe aus data-size="1600x1200"
    			var size = link.getAttribute('data-size');
    			if (size && /^\d+x\d+$/.test(size)) {
    				var parts = size.split('x');
    				item.w = parseInt(parts[0], 10);
    				item.h = parseInt(parts[1], 10);
    				return Promise.resolve(item);
    			}

    			// Fallback: Bild laden und echte Größe auslesen
    			return new Promise(function(resolve) {
    				var probe = new Image();
    				probe.onload = function() {
    					item.w = probe.naturalWidth;
    					item.h = probe.naturalHeight;
    					resolve(item);
    				};
    				probe.onerror = function() {
    					item.w = 1600;
    					item.h = 1200;
    					resolve(item);
    				};
    				probe.src = src;
    			});
    		}
    	}
    }
</script>